import type { Video } from '@/types';
import VideoCard from '@/components/feature/VideoCard';

interface VideoWaterfallProps {
  videos: Video[];
  emptyText?: string;
}

export default function VideoWaterfall({ videos, emptyText = '暂时没有找到相关视频' }: VideoWaterfallProps) {
  if (videos.length === 0) {
    return (
      <div className="w-full py-16 flex flex-col items-center justify-center text-center">
        <span className="w-16 h-16 rounded-full bg-secondary-100 text-secondary-400 flex items-center justify-center mb-4">
          <i className="ri-inbox-line text-3xl"></i>
        </span>
        <p className="text-foreground-600 text-sm">{emptyText}</p>
      </div>
    );
  }

  return (
    <div className="columns-2 lg:columns-3 xl:columns-4 gap-4">
      {videos.map((v) => (
        <VideoCard key={v.id} video={v} />
      ))}
    </div>
  );
}